module.exports = __webpack_public_path__ + "assets/qq.8968a17d.svg";